import { createSelector } from '@reduxjs/toolkit';

import { MIN_PLAY_RANGE_DURATION } from 'constants/trimming';

import { selectPlayerTime } from './videoPlayer';

const selectTrimming = state => state.trimming;

export const selectSendingNewTrim = createSelector(
  selectTrimming,
  trimming => trimming.sendingNewTrim
);

export const selectTrimRanges = createSelector(
  selectTrimming,
  trimming => trimming.trim_ranges
);

export const selectPlayRanges = createSelector(
  selectTrimming,
  trimming => trimming.playRanges
);

export const selectTrimNewChanges = createSelector(
  selectTrimming,
  trimming => trimming.new_changes
);

export const selectCanUndoPlayRange = createSelector(
  selectTrimming,
  ({ playRangeUndoPointer }) => {
    return playRangeUndoPointer > 0;
  }
);

export const selectCanRedoPlayRange = createSelector(
  selectTrimming,
  ({ playRangeUndoStack, playRangeUndoPointer }) => {
    return playRangeUndoPointer < playRangeUndoStack.length - 1;
  }
);

export const selectSelectedPlayRangeIdx = createSelector(
  selectTrimming,
  t => t.selectedPlayRangeIdx
);

export const selectSelectedPlayRange = createSelector(
  selectPlayRanges,
  selectSelectedPlayRangeIdx,
  (ranges, idx) => ranges[idx]
);

export const selectSelectedPlayRangeHandle = createSelector(
  selectTrimming,
  ({ selectedPlayRangeHandle }) => selectedPlayRangeHandle
);

export const selectCurrentTimeInSelectedPlayRangeBounds = createSelector(
  state => ({
    currentTime: selectPlayerTime(state),
    selectedPlayRange: selectSelectedPlayRange(state),
  }),
  ({ currentTime, selectedPlayRange }) => {
    return Boolean(
      currentTime - selectedPlayRange?.from >= MIN_PLAY_RANGE_DURATION &&
        selectedPlayRange?.to - currentTime >= MIN_PLAY_RANGE_DURATION
    );
  }
);

export const selectCanSplitPlayRange = createSelector(
  state => ({
    playRanges: selectPlayRanges(state),
    currentTimeInSelectedPlayRangeBounds:
      selectCurrentTimeInSelectedPlayRangeBounds(state),
    requestCurrentTime: state?.video_player?.request_current_time,
  }),
  ({
    playRanges,
    currentTimeInSelectedPlayRangeBounds,
    requestCurrentTime,
  }) => {
    return Boolean(
      playRanges?.length > 0 &&
        requestCurrentTime == null &&
        currentTimeInSelectedPlayRangeBounds
    );
  }
);

export const selectCanDeletePlayRange = createSelector(
  selectPlayRanges,
  playRanges => Boolean(playRanges?.length > 1)
);

export const selectShowExitWarning = createSelector(
  selectTrimming,
  trimming => trimming.showExitWarning
);
